<template>

    <pedido-proveedor-form :idBusiness="idBusiness" :idPedido="idPedido" :editar="editar"></pedido-proveedor-form>

</template>

<script>
    import PedidoProveedorForm from "./PedidoProveedorForm";
    export default {
        name: "PedidoProveedor",
        components: {PedidoProveedorForm},
        created(){
        },
        data() {
            return {

                idBusiness: this.$route.params.idBusiness,
                idPedido: this.$route.params.idPedido,
                editar:this.$route.params.editar,


            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/pages/Dashboard/PedidosProveedor/PedidoProveedor.vue